module.exports = __webpack_public_path__ + "static/images/smoothness/ui-bg_glass_75_e6e6e6_1x400.png";